module.exports = __webpack_public_path__ + "assets/measure_vehicle_fuel_consumption.f520d926.svg";